export default class LiveNotify {
  constructor(selector) {
    this.notify = document.querySelector(selector);
    if (!this.notify) return;

    this.closeButton = this.notify.querySelector('.js_dke_live-notify__close');
    this.delayTimeNotify = +this.notify.dataset.timeDelay || 3000;
    this.notifyContent = this.notify.querySelector('.js_dke_live-notify__text').innerHTML;

    this.closeButton?.addEventListener('click', () => {
      //(true) - говорит о том что пользователь сам закрыл, 
      //         она больше не будет видна если контент ее не измениться
      this.hideNotify(true);
    });

    if (this.notifyContent !== localStorage.getItem('notifyContent')) {
      //Если контент всплывашки изменился то показывать ее в любом случае
      localStorage.setItem('notifyContent', this.notifyContent);
      localStorage.removeItem('notifyClosed');
      this.showNotify(this.delayTimeNotify);
    } else if (!localStorage.getItem('notifyClosed')) {
      //Если пользователь не закрывал всплывашку?
      this.showNotify(this.delayTimeNotify);
    }
  }

  showNotify(showTime = 3000) {
    setTimeout(() => {
      this.notify.classList.add('js_dke_live-notify_show');
    }, showTime);
  }

  hideNotify(closedByUser = false) {
    this.notify.classList.remove('js_dke_live-notify_show');

    if (closedByUser) {
      localStorage.setItem('notifyClosed', 'closed');
    }
  }
}
